import { render, staticRenderFns } from "./InstitutionUserTable.vue?vue&type=template&id=5aba1e6d"
import script from "./InstitutionUserTable.vue?vue&type=script&lang=js"
export * from "./InstitutionUserTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports